import { useState, useEffect, useCallback } from 'react';
import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

/**
 * Fetches current status of all 3 AI feature flags. Returns
 * { loading, flags: { ai_content_gen, ai_translation, ai_health_insights }, refetch }.
 */
export default function useAiFeatureStatus() {
  const [flags, setFlags] = useState({
    ai_content_gen: false,
    ai_translation: false,
    ai_health_insights: false,
  });
  const [loading, setLoading] = useState(true);

  const refetch = useCallback(async () => {
    setLoading(true);
    try {
      const res = await axios.get(`${API}/ai/status`);
      setFlags(res.data || {});
    } catch (err) {
      // silent — default to all false
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    refetch();
  }, [refetch]);

  return { flags, loading, refetch };
}
